module.exports = "/assets/867c2635fc35aa79645a71858b7f18f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VV.png
// module id = 1940
// module chunks = 0